export enum EnumMainCard {
    PAYROLL_CARDS = 'payroll-cards',
    TIME_MANAGEMENT = 'time-management',
    WAGE_MANAGEMENT = 'wage-management',
    DEMANDS = 'demands',
}
